import type React from 'react';

import { Translate } from '@change-corgi/core-react/i18n';
import { Button } from '@change-corgi/design-system-legacy/components/actions';

export const Buttons: React.FC = () => {
	return (
		<Button type="submit" data-qa="report-abuse-submit-button">
			<Translate value="fe.components.petition_report_abuse.form_submit" />
		</Button>
	);
};
